export default __webpack_public_path__ + "static/media/youtube-inactive.4179251b.svg";